import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

import natureHero from "../../../assets/yala-national-park1.jpg";

import wildlife from "../../../assets/yala-national-park2.jpg";
import cycling from "../../../assets/cycletour.jpg";
import adventure from "../../../assets/adventuretours.jpg";
import walking from "../../../assets/WalkingTours3.jpg";

function NatureTours() {
    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const tours = [
        {
            id: 1,
            title: "Wild Life Tour",
            image: wildlife,
            slug: "wild-life-tour",
            description:
                "A thrilling wildlife tour program taking you deep into Sri Lanka’s jungles, national parks and rich biodiversity."
        },
        {
            id: 2,
            title: "Cycling Tours",
            image: cycling,
            slug: "cycling-tours",
            description:
                "Pedal through scenic villages, tea plantations, forests and coastlines for an immersive nature experience."
        },
        {
            id: 3,
            title: "Adventure Tours",
            image: adventure,
            slug: "adventure-tours",
            description:
                "From trekking and rafting to rock climbing and zip lining, discover Sri Lanka’s wild side with adrenaline-filled journeys."
        },
        {
            id: 4,
            title: "Walking Tours",
            image: walking,
            slug: "walking-tours",
            description:
                "Explore nature, culture and hidden landscapes on foot with guided walking trails across Sri Lanka."
        }
    ];

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${natureHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Nature Tours
                    </h1>
                    <p data-aos="fade-up" data-aos-delay="150" className="mt-6 max-w-3xl">
                        Wildlife tours, Cycling Tours, Adventure Tours & Walking Tours
                    </p>
                </div>
            </section>

            {/* ================= INTRO ================= */}
            <section className="bg-white py-10">
                <div className="mx-auto max-w-5xl px-6 text-center">
                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-8 text-gray-600 leading-relaxed max-w-3xl mx-auto"
                    >
                        The natural beauty of Sri Lanka can surely take your very breath away; laze upon dazzling, golden beaches and listen to the ethereal voices of the sea or embark on an adventurous Sri Lanka safari tour to spot predators on the prowl. This paradise island is filled with simplicity and charm promising all who visit, a perfect opportunity to be at one with nature.
                    </p>
                </div>
            </section>

            {/* ================= TOUR RESULTS ================= */}
            <section className="bg-white py-10">
                <div className="mx-auto max-w-7xl px-6 space-y-20">

                    {tours.map((tour, index) => (
                        <div
                            key={tour.id}
                            data-aos="fade-up"
                            className={`relative grid items-center gap-10 md:grid-cols-2 ${index % 2 === 0 ? "" : "md:flex-row-reverse"}`}
                        >
                            {/* IMAGE */}
                            <div className={`relative ${index % 2 === 0 ? "md:order-1" : "md:order-2"}`}>
                                <div
                                    className={`absolute -inset-y-6 w-[300px] bg-[#0b4c7d] z-0 ${index % 2 === 0 ? "-left-6" : "-right-6"}`}
                                ></div>
                                <img
                                    src={tour.image}
                                    alt={tour.title}
                                    className="relative z-10 h-[330px] w-full object-fill shadow-xl"
                                />
                            </div>

                            {/* TEXT */}
                            <div className={`z-10 ${index % 2 === 0 ? "md:order-2" : "md:order-1"}`}>
                                <h2 className="text-3xl font-bold text-[#0b4c7d] mb-4">
                                    {tour.title}
                                </h2>
                                <p className="text-gray-600 leading-relaxed mb-8">
                                    {tour.description}
                                </p>

                                <button
                                    onClick={() => navigate(`/tours/nature-tours/${tour.slug}`)}
                                    className="rounded-full bg-[#00a7c4] px-8 py-2 text-white font-semibold hover:bg-[#008fa8] transition">
                                    View More
                                </button>
                            </div>
                        </div>
                    ))}

                </div>
            </section>

            {/* ================= WHATSAPP ================= */}
            <a
                href="https://wa.me/94743412910"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default NatureTours;
